import { StatusCodes } from 'http-status-codes';
import { AxiosResponse } from 'axios';


export default class ApiException {
  constructor(
    public message = '',
    public url = '',
    public status = StatusCodes.INTERNAL_SERVER_ERROR,
    public data = '',
    public source = '',
    public response = {} as AxiosResponse,
  ) {}
}
